import { Beacon } from '@/components/forms/FormContext';
import { type StepMap, steps } from '../../constants';

export const contactInfoStepGraph: Beacon<StepMap> = {
	[steps.ContactInfo]: [],
};
